<template>
		<section class="knd-intro">
			<div class="knd-intro__img-container">
				<img class="knd-intro__img" src='@/assets/img/papier.png' />
			</div>
			<div class="knd-container">
				<article>
					<h1 class='knd-title'>{{$store.getters.landing.titel}}</h1>
					<div v-html="$store.getters.landing.intro"></div>
				</article>

				<article class="knd-autocomplete p-t-md p-b-md" @click="inputClick">
					<div class='knd-awesome-input'>
						<input ref='awesomplete' placeholder="zoek op gemeente" />
						<img class="knd-autocomplete__icon" src='@/assets/strooi/marker.svg' />
					</div>
				</article>

				<div v-if="begrotingMist" class='knd-begroting-mist'>
						De begroting van de gemeente {{gemeente.gemeente_naam}} over het jaar 2022 is niet bekend. Zoek op een andere gemeente.
				</div>
			</div>
		</section>

</template>

<script>
	import AutoComplete from '@/components/autocomplete/autocomplete.js';

export default {
	name: 'intro',
	components: {},
	data () {
		return {
			begrotingMist: undefined,
			gemeente: {}
			// inputClicked: false
		}
	},
	mounted: function() {
		this.$store.dispatch('loadData')
		.then(() => {
			this.setAutocomplete();
		})

		
	},
	methods: {
		setAutocomplete() {
			let el = this.$refs.awesomplete;
			let data = this.$store.getters.autoComplete;
			let auto = new AutoComplete(el, data, this.onSearch);
		},

		onSearch(value) {
			this.$store.dispatch('resetGemeente');
			let gemeente = this.$store.getters.getGemeenteById(value);

			if(!gemeente.begroting_ingeleverd) {
				this.gemeente = gemeente;
				this.begrotingMist = true;

				return;
			}

			this.begrotingMist = false;

			this.$store.dispatch('loadGemeente', value);
			this.$store.dispatch('updateGemeente', value)
		},

		// inputClick() {
		// 	console.log("inputClicked");
		// 	if(!this.inputClicked) {
		// 		const container = document.querySelector(".knd-intro")
		// 		const containerHeight = container.clientHeight;
		// 		container.style.minHeight = containerHeight + 80 + "px";
		// 		window.scrollBy(0,80)
		// 		this.inputClicked = !this.inputClicked;
		// 	}
		// }
	} 
}
</script>